import { useQuery } from "@tanstack/react-query";
import { DDD, E2Data, tx } from "../../lib/ddd/ddd";
import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import JsonObject from "../APIPlaygroundComponents/JsonObject";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import classes from "../../pages/IntegrationWizard.module.scss"
import JSONPretty from "../jsonPrettyOverride/JSONPretty";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from "../UI/Button";
import LoadingDots from "../UI/LoadingDots";
import { OrgIdContext } from "../../store/orgId_context";
import Curl from "../APIPlaygroundComponents/Curl";
import StepSmall from "./Step/StepSmall";
import ImageDoc from "./ReturnDoc/ImageDoc";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const allDocTypes = [
    {
      doc: "PDF",
      description: "Primary PDF document for invoice.",
    },
    {
      doc: "PDFO",
      description: "Original PDF document received by service.",
    },
    {
      doc: "XMLS",
      description:
        "Country specific XML of e-invoice. (e.g.: UBL 2.1 with country specific extension fields.)",
    },
    {
      doc: "XMLP",
      description: "Peppol XML for e-invoice.",
    },
  ];

const Docs = ({invoiceId, onExecute}) =>{
    const [stepsInfo, setStepsInfo] = useState([]);
    const [curlCommand, setCurlCommand] = useState("");
    const [curlView, setCurlView] = useState("");
    const [sendingRequestLoad, setSendingRequestLoad] = useState(false);
    const [response, setResponse] = useState(null);
    const [json, setJson] = useState({});
    const [stepsOnOff, setStepsOnOff] =  useState([]);
    const [stepsCompleted, setStepsCompleted] =  useState({});
    const [currentStep, setCurrentStep] =  useState(0);

    const { integrationDevice} = useContext(OrgIdContext);


    useEffect(() => {
    }, []);

    useEffect(() => {
        let id = invoiceId ? invoiceId : null;
        setJson({...json, Id:id, "Complexity": "Normal", "ReturnDoc" : []})
        setStepsOnOff({});

    }, [invoiceId])

    const executeJsonCommand = () =>{
        setSendingRequestLoad(true);
        setResponse("");

        const ddd = DDD.WithConnectionKey(apiRequestAddress, integrationDevice);
        ddd.DDDI_TransformedDocs(json).then((res) => {
            setSendingRequestLoad(false);
            setResponse(res);

            if(onExecute)
                onExecute(res);
        });
    }

    useEffect(() => {
        const jsonString = JSON.stringify(JSON.stringify(json));
        let color = "#12bb12"
        const curlCmd = tx(`curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.DDDI_TransformedDocs -H "Authorization: IoT ${integrationDevice}:EUeInvoices" -H "Content-Type: application/json" -d ${jsonString}`);
        const endpoint = tx("EUeInvoices.DDDI_TransformedDocs");
        const curlCmdView = <span>curl -X POST https://{window.location.hostname}/api/service/<span style={{color:color}}>{endpoint}</span> -H "Authorization: IoT <span style={{color:color}}>{integrationDevice}</span>:EUeInvoices" -H "Content-Type: application/json" -d <span style={{color:color}}>{jsonString}</span></span>
        setCurlCommand(curlCmd);
        setCurlView(curlCmdView);
    }, [json, integrationDevice])

    const onStepChanged = (step, value) =>{
        let newSteps = {...stepsOnOff, [step]:value};
        console.log(newSteps);
        setStepsOnOff(newSteps);
        refreshJson(newSteps);
    }

    const refreshJson = (steps) =>{
        let arr = [];
        for(let x in steps){
            if(steps[x] === true)
                arr.push(x);
        }
        setJson({...json, ReturnDoc:arr})
    }

    

    return(
        <>
        <Row className = "g-5">
            <Col className="col-md-6 order-md-last">
                <div className={classes["steps-wrapper"]} style={{textAlign:"center"}}>
                    <h3>{tx("DDDI_TransformedDocs")}</h3>
                    This is the command you can execute from your side or click on the execute button bellow.
                    <Curl
                        currentCurl={curlCommand}
                        currentCurlView={curlView}
                        currentJson={json}
                        activeApi="DDDI_TransformedDocs"
                        connectionKey={integrationDevice}
                    />
                    <Button style={{fontSize:"2rem", marginTop:"1rem", marginBottom:"1rem"}} onClick={executeJsonCommand}><CloudUploadIcon style={{marginRight:"1rem"}}/>Execute</Button>
                    {sendingRequestLoad && (<LoadingDots />)}
                    {!sendingRequestLoad && response!==null && (
                    <div style={{textAlign : "left", paddingTop : "5px"}} id="execute-json-response">
                        <JsonObject response={response} />
                    </div>
                    )}
                </div>
            </Col>
            
            <Col className="col-md-5">
                <div className={`${classes["steps-wrapper"]}`} style={{height:"16vh", marginBottom:"1rem"}}>
                    <Container>
                        <Row className="p-1 gy-1">
                            {allDocTypes.map((doc) => 
                                <Col>
                                <ImageDoc key={doc.doc} doc={doc.doc} onDocClicked ={onStepChanged} checked ={stepsOnOff[doc.doc]}/>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </div>
                <div className={`${classes["form-wrapper"]} ${classes["form-wrapper-json"]}`} style={{textAlign : "left", height:"35vh"}} >
                    <JSONPretty data={json} ></JSONPretty>
                </div>
                
            </Col>
            <Col className="my-auto p-0 m-0">
                <div ><ArrowForwardIcon style={{fontSize:"2rem"}}/></div>
            </Col>
        </Row>
        </>
    )
}

export default Docs;
